import styled, { css } from 'styled-components';
import Btn from 'core/ui/Button';
import { size, resetBtn } from 'styled-manila';
import { getColor, typeScale } from 'core/utils';

export const BorderBox = styled.div`
	@media (min-width: 768px) {
		padding: ${typeScale(2.5)} ${typeScale(2)};
		${({ isSticky }) => !isSticky && css`
			border: 1px solid ${getColor("alto")};
			border-radius: 8px;
		`}

		${({ isSticky }) => isSticky && css `
			padding-bottom: 0;
		`}

		& + & {
			${({ isSticky }) => !isSticky && css `
				margin-top: 20px;
			`}

			${({ isSticky }) => isSticky && css `
				padding-top: 0;
			`}
		}

		hr {
			margin-left: -16px;
			width: calc(100% + 32px);
		}
	}
`;

export const Title = styled.h6`
	margin: 0;
	font-size: 16px;
	line-height: 1.5;
	letter-spacing: -0.4px;
	color: ${getColor("gray")};
	margin-bottom: 12px;
	font-weight: 700;
`;

export const PolicyBox = styled.div`
	@media (min-width: 768px) {
		margin-bottom: 30px;
	}
`;

export const Text = styled.p`
	color: ${getColor("gray9")};
	font-weight: 600;
	font-size: 12px;
	line-height: 18px;
	letter-spacing: 0.24px;
`;

export const OtherDetails = styled.p`
	font-size: 14px;
	font-weight: 600;
	line-height: 22px;
	letter-spacing: 0.2px;
	margin-bottom: 16px;
	color: ${getColor("gray")};
`;

export const SubHeading = styled.div`
	color: ${getColor("gray9")};
	display: block;
	font-weight: 600;
	font-size: 12px;
	line-height: 18px;
	letter-spacing: 0.24px;
	margin-bottom: 4px;
`;

export const Price = styled.h2`
	font-weight: 600;
	font-size: 33px;
	line-height: 29px;
	letter-spacing: 0.2px;
	color: ${getColor("gray")};
	margin: 4px 0 16px;
`;

export const CurrencyCode = styled.span`
	font-weight: 600;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	color: ${getColor("gray")};
`;
export const Interval = styled.span`
	font-weight: 600;
	font-size: 16px;
	line-height: 17px;
	letter-spacing: 0.2px;
	color: ${getColor("gray")};
`;

export const DetailsRow = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 4px;
`;

export const Button = styled(Btn)`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 16px;
	padding: 0 16px;
`;

export const ShippingScheduleWrapper = styled.div`
	margin-bottom: 20px;
`;

export const Discount = styled.span`
	font-weight: 600;
	font-size: 14px;
	line-height: 1.4;
	color: ${getColor('malachite')};
`;

export const DiscountWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: ${typeScale(2)};
	background-color: ${getColor('lightMint')};
	margin-bottom: ${typeScale(2)};

	svg {
		margin-right: 10px;
		${size(18)};
		min-width: 18px;
	}
`;

export const Deal = styled.span`
	font-weight: 600;
	font-size: 14px;
	line-height: 1.4;
	color: ${getColor('white')};
`;

export const DealWrapper = styled.div`
	display: flex;
	align-items: center;
	padding: ${typeScale(2)};
	background-color: ${getColor('mulberry')};
	margin-bottom: ${typeScale(2)};

	svg {
		margin-right: 10px;
		${size(18)};
		min-width: 18px;
	}
`;

export const Subprice = styled.span`
	color: ${getColor("gray")};
	display: block;
	font-size: 14px;
	margin-bottom: 30px;
`;

export const ClaimWrapper = styled.div`
	padding-top: 2px;
`;

export const SpinWrapper = styled.div`
	margin: 4px 0 16px;
	height: 30px;
	align-items: center;
	display: flex;
`;

export const SellerBtn = styled.button`
	${resetBtn};
	display: inline-block;
	color: ${getColor("primaryBrand")};
`;
